import { MbConstants } from '../../../mb-constants'
import { Directive, Input } from '@angular/core'
import { MbCheckoutRegions } from '../../../../models'

@Directive()
export abstract class MbAbstractInformationTileComponent {

  constants = MbConstants
  checkoutRegions = MbCheckoutRegions

  @Input() title: string | undefined
  @Input() data: any
  @Input() isEditable = false
  @Input() linkToEditComponent: string | undefined
  @Input() formRegion = this.checkoutRegions.EU
  @Input() salesTaxLabelKey = 'address.salesTaxExemption'
  @Input() vatIdLabelKey = 'address.vatId'
  @Input() poNumberLabelKey = 'review.poInternalRefNum'

  get hasSalesTaxExemption () {
    return !this.data?.shippingAddress && this.data?.hasOwnProperty(this.constants.SALES_TAX_EXEMPT_CODE)
  }
}
